import { useParams } from "react-router-dom";
import { useBoards } from "../utils/reactQuery/boards";
import { isNumericBoardId } from "../utils/boardUtils";

/**
 * Hook to get the board ID from the board key in the URL params
 * Supports both new URL format (with board key) and old format (with numeric ID)
 * 
 * @returns {Object} Object containing id (board_id) and board object
 */
const useBoardIdByKey = () => {
  const { id } = useParams();
  const { isLoading, boards, isError } = useBoards();
  
  if (isLoading || isError || !boards?.data?.data?.responseData) {
    return { id: null, board: null, isLoading, isError };
  }
  
  const responseData = boards.data.data.responseData;
  
  // Handle both key and numeric ID formats
  if (isNumericBoardId(id)) {
    // For backward compatibility: if ID is numeric, find board by board_id
    const board = responseData.find((board) => board.board_id === parseInt(id));
    return { id: board?.board_id, board, isLoading, isError };
  } else {
    // Current approach: find board by key
    const board = responseData.find((board) => board.key === id);
    return { id: board?.board_id, board, isLoading, isError };
  }
};

export default useBoardIdByKey;